export default __webpack_public_path__ + "static/media/蒙版组 10@2x.782a1a28.png";